export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.446 4.5a2.5 2.5 0 012.426 3.104l-1.407 5.636.005.002-.568 2.273A2 2 0 0021.842 18H23v2h-1.157c-.116 0-.23-.007-.343-.017V20H3.42a2.5 2.5 0 01-2.426-3.105l2.618-10.5A2.5 2.5 0 016.038 4.5h13.408zm-13.408 2a.5.5 0 00-.486.379l-2.618 10.5A.5.5 0 003.42 18h13.408a.5.5 0 00.485-.379l2.618-10.5a.5.5 0 00-.485-.621H6.038z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};